import { createAuth0Client } from "@auth0/auth0-spa-js";

let auth0Client = null;

export const initAuth = async (mode = "redirect") => {
    if (auth0Client) return auth0Client;

    auth0Client = await createAuth0Client({
        domain: import.meta.env.VITE_AUTH0_DOMAIN,
        clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
        authorizationParams: {
            // redirect_uri: mode === "redirect" ? window.location.origin : "http://localhost:5173/login/callback",
            redirect_uri: mode === "redirect" ? window.location.origin : import.meta.env.VITE_REDIRECT_URI_AUTH0,
            scope: "openid profile email",
            // Tambahkan audience jika kamu butuh akses ke API backend kamu nanti
            // audience: "https://api.kamu.com" 
        }
    });

    return auth0Client;
};

export const login = async () => {
    const client = await initAuth();
    // Langsung ke Auth0, tidak lewat API PHP lagi
    await client.loginWithRedirect();
};

export const handleRedirect = async () => {
    const client = await initAuth();
    // Cek apakah ada code dari Auth0 di URL
    if (window.location.search.includes("code=")) {
        await client.handleRedirectCallback();
        window.history.replaceState({}, document.title, window.location.pathname);
    }
};

export const checkSessionStatus = async () => {
    try {
        const client = await initAuth();
        // Ini kunci SLO: mengecek apakah cookie di domain Auth0 masih ada
        const token = await client.getTokenSilently({
            cacheMode: "off" // hit api auth0 untuk check token
        });
        return true;
    } catch (e) {
        return false;
    }
};

export const getTokenSso = async () => {
    try {
        const client = await initAuth();

        const query = window.location.search;
        if (query.includes("code=") && query.includes("state=")) {
            await client.handleRedirectCallback();
            // Bersihkan URL agar handleRedirectCallback tidak dipanggil ulang saat refresh
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        // Ini kunci SLO: mengecek apakah cookie di domain Auth0 masih ada
        const token = await client.getTokenSilently({
            cacheMode: "off" // hit api auth0 untuk check token
        });

        return token;
    } catch (e) {
        return null;
    }
};

export const logout = async () => {
    const client = await initAuth();
    const urlLogin = import.meta.env.VITE_AUTH0_LOGIN_URL;
    await client.logout({
        logoutParams: { returnTo: urlLogin }
    });
};

export const logoutSSOWithPopup = async () => {
    const client = await initAuth();
    
    await client.logout();
};